import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePostHog } from 'posthog-js/react';

// Customer-facing and pre-auth route prefixes where the support chat widget
// must not appear. Everything else is an authenticated shop page.
const UNAUTHENTICATED_PATH_PREFIXES = [
  '/login',
  '/signup',
  '/auth',
  '/forgot-password',
  '/reset-password',
  '/s/',
  '/public/',
  '/pay/',
  '/book/',
  '/invite/',
];

export const PostHogConversationsController = () => {
  const posthog = usePostHog();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!posthog.conversations.isAvailable()) {
      return;
    }

    const shouldHide = UNAUTHENTICATED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

    if (shouldHide) {
      posthog.conversations.hide();
    } else {
      posthog.conversations.show();
    }
  }, [posthog, pathname]);

  return null;
};
